var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisa = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134 100",
    style: {
      enableBackground: "new 0 0 134 100"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -99.8267,
    y1: 80.7468,
    x2: -99.2874,
    y2: 80.7468,
    gradientTransform: "matrix(-447.2577 2.6392 2.6392 447.2577 -44741.2383 -35801.4805)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#222357"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#254AA5"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,99.5H125c4.4,0,8-3.6,8-8V68.1V33.5v-9.8V8.5c0-4.4-3.6-8-8-8H76.6H52.7H9c-4.4,0-8,3.6-8,8v6.1v19v34.6 v23.4C1.1,95.9,4.6,99.5,9,99.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M68.9,43.7c-0.1,4.9,4.3,7.6,7.6,9.2c3.4,1.7,4.5,2.7,4.5,4.2c0,2.3-2.7,3.3-5.2,3.3c-4.4,0.1-6.9-1.2-8.9-2.1 l-1.6,7.4c2,0.9,5.8,1.8,9.7,1.8c9.2,0,15.1-4.5,15.2-11.5c0-8.9-12.3-9.4-12.2-13.4c0-1.2,1.2-2.5,3.7-2.8 c1.2-0.2,4.7-0.3,8.6,1.5l1.5-7.1c-2.1-0.8-4.8-1.5-8.2-1.5C75,32.6,68.9,37.2,68.9,43.7 M106.4,33.2c-1.7,0-3.1,1-3.7,2.5 L89.7,66.9h9.1l1.8-5h11.2l1.1,5h8.1l-7-33.7H106.4 M107.7,42.3l2.6,12.6h-7.2L107.7,42.3 M57.8,33.2l-7.2,33.7h8.7l7.2-33.7H57.8  M44.9,33.2l-9.1,22.9l-3.7-19.5c-0.4-2.2-2.1-3.4-4-3.4H13.3l-0.2,1c3,0.7,6.5,1.7,8.6,2.9c1.3,0.7,1.6,1.3,2.1,3l6.9,26.9h9.2 L54,33.2L44.9,33.2"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/visa.0c7ee2ca9ff4e50f342e52257e7e75b8.svg";